import script from "./PagingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PagingBar.vue?vue&type=script&setup=true&lang=ts"

import "./PagingBar.vue?vue&type=style&index=0&id=629c26af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629c26af"]])

export default __exports__